import axios from "axios";

export function calculateShipping(
  products,
  postalCode,
  street,
  country,
  state,
  forceBox,
  boxConstraints = null,
  departmentId = null,
  forceRecalculate = false
) {
  console.log("calculate inside");
  const params = {
    // Residencial o comercial lo decide el API con la calle (street1, street2, city)
    address: {
      ...street,
      country: country,
      postal_code: postalCode,
      state: state
    },
    cart: products.map(product => {
      return {
        cartQty: product.quantity,
        sku: product.nkrCode,
        price: product.price
      };
    }),
    forceBox,
    adminServices: true,
    forceRecalculate
  };

  // Add department ID if provided
  if (departmentId) {
    params.departamento_id = departmentId;
  }

  // Add box constraints if provided
  if (boxConstraints) {
    const constraints = {};
    if (boxConstraints.maxWeight)
      constraints.maxWeight = boxConstraints.maxWeight;
    if (boxConstraints.maxLength)
      constraints.maxLength = boxConstraints.maxLength;
    if (boxConstraints.maxWidth) constraints.maxWidth = boxConstraints.maxWidth;
    if (boxConstraints.maxHeight)
      constraints.maxHeight = boxConstraints.maxHeight;
    if (boxConstraints.maxLengthPlusGirth)
      constraints.maxLengthPlusGirth = boxConstraints.maxLengthPlusGirth;

    if (Object.keys(constraints).length > 0) {
      params.boxConstraints = constraints;
    }
  }

  return axios
    .post(process.env.VUE_APP_WEB_API + "/shipping/calculator", params)
    .then(res => res.data);
}
